(function () {
  'use strict';
  if (window.htsCurrencyFallback || /\/(checkouts?|orders|account)(\/|$)/.test(location.pathname)) return;
  window.htsCurrencyFallback = { version: '20260922' };
  var key = 'hts_currency_preference_v1';
  var readyAt = 0;
  var pending = false;
  function read(storage, name) {
    try { return JSON.parse(storage.getItem(name)); } catch (_) { return null; }
  }
  function write(storage, name, value) {
    try { storage.setItem(name, JSON.stringify(value)); return true; } catch (_) { return false; }
  }
  function preference() {
    try { return read(localStorage, key); } catch (_) { return null; }
  }
  function check() {
    pending = false;
    var app = window.bucksCC;
    if (!app || !app.Currency || !app.Currency.rates || typeof app.reConvert !== 'function') return;
    var config = app.metaConfig || {};
    // Never turn this display-only patch into a Markets currency/checkout change.
    if (config.isMerchant || (config.multiCurrencies || []).length > 1 || !config.autoSwitchCurrencyLocationBased) return;
    if (!readyAt) readyAt = Date.now();
    var current, geo, country, oldManual;
    try {
      current = read(sessionStorage, 'buckscc_customer_currency');
      geo = read(sessionStorage, 'hxoGeoCurrency');
      country = read(sessionStorage, 'hxoGeoCountry');
      oldManual = read(localStorage, 'buckscc_last_manual');
    } catch (_) { return; }
    var pref = preference();
    var explicit = new URLSearchParams(location.search).get('bucks_currency') || new URLSearchParams(location.search).get('currency');
    if (!pref && explicit && /^[A-Z]{3}$/.test(explicit.toUpperCase()) && app.Currency.rates[explicit.toUpperCase()]) {
      pref = { mode: 'manual', currency: current || explicit.toUpperCase() };
      write(localStorage, key, pref);
    }
    if (!pref && oldManual && oldManual.currency === current) {
      pref = { mode: 'manual', currency: current }; write(localStorage, key, pref);
    }
    // A pre-existing session choice with no location is ambiguous: preserve it.
    if (!pref && current && !geo) return;
    var supported = ['MYR'];
    var list = config.selectedCurrencies || [];
    if (typeof list === 'string') { try { list = JSON.parse(list); } catch (_) { return; } }
    list.forEach(function (item) { supported.push(Object.keys(item)[0]); });
    var target;
    if (pref && pref.mode === 'manual') target = pref.currency;
    else {
      if (!geo && !country && Date.now() - readyAt < 8000) return;
      target = country === 'MY' ? 'MYR' : (supported.indexOf(geo) !== -1 ? geo : 'USD');
    }
    if (!target || !app.Currency.rates[target]) return;
    if (current !== target) {
      if (!write(sessionStorage, 'buckscc_customer_currency', target)) return;
      app.reConvert();
      if (app.addCartBanner) app.addCartBanner();
    }
    window.htsCurrencyFallback.currency = target;
    window.htsCurrencyFallback.mode = pref && pref.mode === 'manual' ? 'manual' : 'auto';
  }
  function schedule() {
    if (!pending) { pending = true; setTimeout(check, 0); }
  }
  // Capture genuine choices before BUCKS handles the same click.
  document.addEventListener('click', function (event) {
    var item = event.target.closest && event.target.closest('.buckscc-select-options .converterTriggers');
    if (!item || !event.isTrusted) return;
    var auto = item.classList.contains('geoCurrency');
    var currency = item.getAttribute('rel') || item.id;
    if (auto || /^[A-Z]{3}$/.test(currency)) {
      write(localStorage, key, auto ? { mode: 'auto' } : { mode: 'manual', currency: currency });
      schedule();
    }
  }, true);
  document.addEventListener('BUCKS_SELECTED_CURRENCY', schedule);
  window.addEventListener('BUCKSCC-LOADED', schedule);
  window.addEventListener('pageshow', schedule);
  var attempts = 0;
  var timer = setInterval(function () {
    check();
    if (++attempts >= 120) clearInterval(timer);
  }, 500);
  schedule();
}());
